export const ApplicationState = {
    ROUND_STARTING: 'round-starting',
    ROUND_IN_PROGRESS: 'round-in-progress',
    NO_FUTURE_ROUND: 'no-future-round',
    LOADING_DATA: 'loading-data'
}
